import { ProfessionalSelectionSearchService } from './professionalSelectionSearch/professionalSelectionSearch.model'
import { ProfessionalSelectionHistoryService } from './professionalSelectionHistory/professionalSelectionHistory.model'

enum ContractType {
  indefinite = 'Indefinido',
  substitution = 'Sustitución',
  temporal = 'Temporal',
}

enum ProfessionalProfile {
  nurse = 'Enfermería',
  auxiliaryNurse = 'Auxiliar de enfermería',
  patientCareTechnician = 'Técnico/a de cuidado a pacientes',
}

export { ProfessionalSelectionSearchService, ProfessionalSelectionHistoryService, ContractType, ProfessionalProfile }



// WEBPACK FOOTER //
// ./src/domain/model/nursingHome/professionalSelection/professionalSelection.model.ts